var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.6 30.5",
    style: {
      enableBackground: "new 0 0 55.6 30.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EA336B;}\n\t.st1{fill:#BD336B;}\n\t.st2{fill:#842751;}\n\t.st3{opacity:0.6;fill:#D177B8;}\n\t.st4{fill:#DE8DB3;}\n\t.st5{fill:#FFFCB8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.6,7c0,0,6,21.5,25.1,21.5C46.1,28.5,52.3,8,52.3,8s-6.8,4.7-24.5,4.7C10.1,12.6,1.6,7,1.6,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.1,8.6c0,0-11.2,4-23.3,4c-8.5,0-16.9-2.3-21.1-3.7C6.6,9,6.5,8.9,6.4,8.9l-1-0.4C5,8.4,4.7,8.3,4.4,8.2 L3.9,8L4,7.9C4.8,7.5,11.8,0.3,26.2,0c0.5,0,1,0,1.5,0c0.5,0,1,0,1.5,0c13.3,0.3,19.9,7.4,21.5,8.3C51,8.5,51.1,8.6,51.1,8.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.2,6.2C0.1,6.1,0.1,6.1,0,6C0,6,0.1,6.1,0.2,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.8,11.8C10.1,12,1.4,6.9,0.2,6.2c10.7,7.1,27.6,9.1,27.6,9.1s17-2,27.7-9.1C54.2,6.9,45.5,12,27.8,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.4,6.2C55.5,6.1,55.6,6,55.6,6C55.5,6.1,55.5,6.1,55.4,6.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.8,21.2c0,0,7,9.3,17.7,9.3c10.7,0,16.7-9.3,16.7-9.3s-5.8,5.5-17.2,5.5C15.5,26.7,9.8,21.2,9.8,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4,7.9C4.8,7.5,11.8,0.3,26.2,0C14,0.4,7.2,8.7,6.7,9c0,0,0,0,0,0L6.4,8.9l-1-0.4l-1-0.3L4,7.9L4,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.7,8.4L48.9,9c0,0-7-8.6-19.6-9C42.5,0.3,49.1,7.4,50.7,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.6,11.3c0,0,12.4,2.4,25.2,0c0,0-4.7,2.7-12.6,3.1S15.6,11.3,15.6,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.1,16.7c0,0,1.4,1.8,1.6,5.6l3.2-0.5c0,0,0.1-2.2-2.1-5.8L31.1,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.2,15.3c0,0,2.1,2.6,2.2,5.9h0.7c0,0,0.4-2.8-2.1-5.9H36.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth2);
export default __webpack_public_path__ + "static/media/Mouth2.fdca34b1792996fa67cca201ebb5cf82.svg";
export { ForwardRef as ReactComponent };